import React, { useState, useEffect } from 'react'
import { Button, CircularLoader, IconButton, Modal, Select } from '@st-operations/uikit/src/v2'
const TEAM_ID = require('../../../constants/sharethis_team_id.js')
import { getPermissionSet, setPermissionToUser } from '_services/permissions'
import { logErrorAsync } from '_lib/utility'
import User from '_lib/User'

export const PermissionSetModal = ({ id, onClose }) => {
  const [permissionSetInfo, setPermissionSetInfo] = useState({})
  const [selectedUser, setSelectedUser] = useState('')
  const [users, setUsers] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  async function fetchPermissionSetInfo() {
    setIsLoading(true)
    try {
      const response = await getPermissionSet(id)
      setPermissionSetInfo(response)
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    fetchPermissionSetInfo()
  }, [id])

  useEffect(() => {
    setIsLoading(true)

    User.getTeamInfo(TEAM_ID, (err, team) => {
      if (err) {
        toast.error('Error getting your team information')
      } else {
        team.users.sort((a, b) => (a.email > b.email ? 1 : -1))
        setUsers(team.users.map((user) => ({ label: user.email, value: user._id })))
      }
      setIsLoading(false)
    })
  }, [])

  const handleAddUserToPermissionSet = async (event) => {
    event.preventDefault()

    try {
      await setPermissionToUser(id, selectedUser)
      fetchPermissionSetInfo()
      setSelectedUser('')
      toast('User added to permission set')
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  const handleSelectedUserChange = (value, name, option) => {
    setSelectedUser(option)
  }

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      classes={{
        content: 'w-[1000px]',
        childWrapper: 'w-full',
        innerWrapper: 'w-full',
      }}
    >
      <section title="Edit permission set" className="use-preflight">
        <div className="grid grid-cols-2 gap-2 min-w-lg my-4">
          <If condition={isLoading}>
            <div className="col-span-2">
              <div className="flex justify-center items-center h-24">
                <CircularLoader className="border-4" />
              </div>
            </div>
          </If>
          <If condition={!isLoading}>
            <table className="border border-gray rounded-lg w-full border-separate">
              <thead>
                <tr className="bg-gray-200 text-left border-b border-gray">
                  <th className="header-4 py-2 pl-4">Email</th>
                  <th className="w-[24px]">&nbsp;</th>
                </tr>
              </thead>

              <tbody>
                <>
                  <For each="user" of={permissionSetInfo.users || []}>
                    <tr
                      key={user._id}
                      className="px-4 py-2 border-b border-gray-200 last-child:border-gray text-left"
                    >
                      <td className="body-md pl-4 py-2">{user.email}</td>
                      <td>
                        <div className="flex gap-1 items-end">
                          <IconButton
                            iconProps={{
                              icon: 'trash',
                              width: 24,
                              height: 24,
                              color: 'currentColor',
                            }}
                            className="cursor-disabled opacity-50 hover:bg-white"
                            disabled
                            text="Not implemented yet"
                          />
                        </div>
                      </td>
                    </tr>
                  </For>
                  <tr>
                    <td colSpan="2">
                      <form
                        className="px-4 py-2 border-b border-gray-200 last-child:border-gray flex gap-2 items-center"
                        onSubmit={handleAddUserToPermissionSet}
                      >
                        <Select
                          type="text"
                          placeholder="Enter user email"
                          className="w-full grow m-0"
                          onChange={handleSelectedUserChange}
                          value={selectedUser}
                          options={users}
                          menuPortalTarget={document.body}
                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          useReactSelect
                        />
                        <div className="flex gap-1 items-end">
                          <Button
                            type="submit"
                            className="whitespace-nowrap m-0"
                            loading={isLoading}
                          >
                            Add user
                          </Button>
                        </div>
                      </form>
                    </td>
                  </tr>
                </>
              </tbody>
            </table>
            <pre className="min-w-lg bg-gray-200 rounded-lg overflow-auto p-4 text-left">
              <code>{JSON.stringify(permissionSetInfo.permissions, null, 2)}</code>
            </pre>
          </If>
        </div>
      </section>
    </Modal>
  )
}
